var productCardMarkup = 
  `<div class="row" id="product-grid">
  {{#products}} 
    <div class="snippet-product-grid">
    <div class="grid-imagebox">
      <a href="{{du}}" class="product-link">
        <div class="product-images">
          <img src="{{iu}}" alt="product-image" >
        </div>
      </a>
      <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="removewishlist swym-delete-btn">
        <span class="wishlist-delete-text">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
<path d="M14.7002 4.82289C14.5372 5.90003 13.8144 6.6441 13.0703 7.38109C12.4396 8.00469 11.8019 8.6283 11.157 9.25899C10.172 10.2298 9.18697 11.2007 8.20196 12.1715L7.99646 12.377C7.92559 12.3061 7.84764 12.2353 7.78386 12.1715C6.79885 11.2007 5.81384 10.2298 4.82883 9.25899C4.19105 8.6283 3.55327 8.00469 2.9155 7.38109C2.17142 6.6441 1.44152 5.90003 1.28562 4.82289C1.08011 3.48356 1.78167 2.13714 2.92967 1.44976C3.83673 0.911188 4.97764 0.861583 5.9414 1.2726C6.72799 1.59857 7.41537 2.27887 8.00354 2.92373C8.59172 2.28595 9.27201 1.59857 10.0586 1.2726C11.0224 0.861583 12.1633 0.911188 13.0703 1.44976C14.2183 2.13714 14.9199 3.48356 14.7144 4.82289H14.7002Z" fill="#C0B8AD" stroke="#C0B8AD" stroke-miterlimit="10"/>
</svg>
        </span>
      </button>
      <div class="grid-variant-outer hide-variant-mobile">
        <div class="variants_options_main" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}"></div>
         <div class="btn_action">
       
        <button id="swym-custom-add-toCartBtn {{available}}" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn product-addcart swym-add-to-cart-btn swym-button swym-button-1 swym-is-button center_align variant-grid quick-add btn w-100" {{^available}}style="pointer-events:none;opacity:0.5{{/available}}">
    {{#available}}  bestel nu {{/available}}{{^available}}Uitverkocht {{/available}}
        </button>
       
      
      </div>
      </div>
    </div>
    <div class="grid-meta product_description row space_between">
      <div class="desc_left">
        <p class="pro_title first"><a href="{{du}}">{{dt}}</a></p>
        <p class="pro_title last">{{dt1}}</p>
      </div>
      <div class="desc_right">
        <p class="pro_price">{{cu}}{{pr}}</p>
      </div>
      
     
    </div>
  </div>
  {{/products}}
</div>`;
var variantModalMarkUp = `
    
      <div class="modal-guts ">
        {{#product.options}}
          <ul class="select-variant-{{name}} user-options grid-size-variants">
            {{#values}}
            <li class="sywm-radio variant-grid" data-val="{{.}}" >
			  <input type="radio" name="{{name}}" data-value="{{.}}" id="user-option{{.}}-{{product.id}}" >
              <label for="user-option{{.}}-{{product.id}}">{{.}}<span class="favourite-dots"></span></label>
            </li>
            {{/values}}
          </ul> 
        {{/product.options}}
      </div>`;   
    
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

// Add global listener for wishlist updates to refresh the page when items are added
window.SwymCallbacks.push(function(swat) {
  if (swat) {
    let addEvent = 'sw:addedtowishlist';
    let removeEvent = 'sw:removedfromwishlist';
    
    // Define the event listener function for adding items
    let addListener = function(e) {
      // Only refresh if we're on the wishlist page
      if (document.getElementById("wishlist-items-container")) {
        setTimeout(function() {
          swymRenderWishlist(swat);
        }, 500); // Small delay to ensure the item is added to Swym's storage
      }
    };
    
    // Define the event listener function for removing items  
    let removeListener = function(e) {
      // Only refresh if we're on the wishlist page
      if (document.getElementById("wishlist-items-container")) {
        setTimeout(function() {
          swymRenderWishlist(swat);
        }, 500); // Small delay to ensure the item is removed from Swym's storage
      }
    };
    
    // Add listeners for wishlist events
    swat.evtLayer.addEventListener(addEvent, addListener);
    swat.evtLayer.addEventListener(removeEvent, removeListener);
    
    // Also add page visibility listener to refresh when page becomes visible
    // This helps when users navigate back to wishlist page after adding items elsewhere
    if (document.getElementById("wishlist-items-container")) {
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          setTimeout(function() {
            swymRenderWishlist(swat);
          }, 300);
        }
      });
      
      // Also refresh on page focus
      window.addEventListener('focus', function() {
        setTimeout(function() {
          swymRenderWishlist(swat);
        }, 300);
      });
    }
  }
});

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    //WishlistedProducts = structuredClone(products);
    // console.log("products-->",products)
    // console.log(products.length,'-----------pl')
    
    // Check if wishlist container exists (only on wishlist page)
    var wishlistContainer = document.querySelector('.wishlist-content .empty-wishlist');
    if (!wishlistContainer) {
      return; // Not on wishlist page, exit early
    }
    
    if (products.length > 0) {
      wishlistContainer.classList.add('active')
    }else{
      wishlistContainer.classList.remove('active')
    }
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
           var colorname = fullProductDetails.variants[j].option2;
           WishlistedProducts[i].option2 = colorname;
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        }
        if(i == (WishlistedProducts.length -1 )){
            const editSchoolName = (jsonData) => {
              return jsonData.map(item => {
              var temp = Object.assign({}, item);
              var newDT = temp.dt.split("-")[0];
              var newDT1 = temp.dt.split("-")[1];
              
                var datavailable = fullProductDetails.available;
              temp.dt = newDT;
              temp.dt1 = newDT1;
                temp.datavailable = datavailable;
              return temp;
              });
            }
            var updatedSchools = editSchoolName(WishlistedProducts);
            console.log('updatedSchools',updatedSchools)
            var wishlistContentsContainer = document.getElementById("wishlist-items-container");
            var formattedWishlistedProducts = updatedSchools.map(function(p) {
            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            return p;
            });
            var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
              products: updatedSchools
            });
            if(wishlistContentsContainer){
              wishlistContentsContainer.innerHTML = productCardsMarkup;
              
              countWishlist();
              attachClickListeners();
            } else{
            console.log("Container not found, Wishlist Page element not found");
            }
          }
      });
      
    }
 
  });

}
function attachClickListeners() {
  var AddVariants = document.querySelectorAll(".variants_options_main");
  // document.querySelectorAll(".sywm-radio input").addEventListener("change",function(evtt){
  //   console.log("parent",evtt)
  // })
  for (var i = 0; i < AddVariants.length; i++) {
    ShowVariants(AddVariants[i])
  }
  var removeBtns = document.querySelectorAll(".removewishlist");
    for (var k = 0; k < removeBtns.length; k++) {
      removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  var addToCartButtons = document.querySelectorAll(".swym-add-to-cart-btn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
}
function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          // Re-render the wishlist immediately after removal
          swymRenderWishlist(window._swat);
        });
      }
    });
  });
}
function ShowVariants(evt) {
  completeProductJson = {};
  var productId = evt.getAttribute("data-product-id");
  var variantId = evt.getAttribute("data-variant-id");
  var variantTitle = evt.getAttribute("data-variant-name");
  var du = evt.getAttribute("data-url");
  var params = {
    du: du,
    empi: parseInt(productId),
    epi: parseInt(variantId)
  }
  
  variantButtonAttributes = {};
  variantButtonAttributes = params; 
  window._swat.getProductDetails(params, function(productJson) { 
	completeProductJson = productJson;
    productJson.du = du;

    if(productJson.options[0].name  != 'Title' ){
      evt.closest('.grid-variant-outer').querySelector('.btn_action').innerHTML = "";
      renderModalUI(productJson,evt);
      var jsonvariantid = productJson.variants;
      jsonvariantid.forEach(function(i,value){      
        if (i.available == false){
          $('.sywm-radio [data-value="'+i.title+'"]').prop('disabled',true);
        }
       else{
         $('.sywm-radio[data-val="'+i.title+'"]').attr('data-id',i.id);
       }
        var allvarName = i.title;
        if(allvarName == variantTitle){
          $('.sywm-radio [data-value="'+variantTitle+'"]').prop('checked',true);
        }
      });
       quickAddButton();
    }
      
    else{
     
    }
  });
}
function renderModalUI(productJson,event) {
  var modalElem = event;
console.log('productJson',productJson)
  var variantMarkUpTemplate = SwymUtils.renderTemplateString(variantModalMarkUp, {
    product: productJson
  });
  
 modalElem.innerHTML = variantMarkUpTemplate;

   var varid = parseInt(event.getAttribute('data-variant-id'));
  var myjson = productJson.variants;
      var result = myjson.find(item => item.id === varid);
  // attachModalEventListeners(event)
     event.querySelectorAll('input[type="radio"]').forEach(function(e,i){
          let attrname =  e.getAttribute('name') + varid;
          // let Changeid =  e.getAttribute('id').split(" ").join("")+'-'+varid;
          // let ChangeFor = e.nextElementSibling.getAttribute('for').split(" ").join("")+'-'+varid;
          e.setAttribute('name',attrname);
          // e.setAttribute('id',Changeid);
          // e.nextElementSibling.getAttribute('for',ChangeFor);
     })
      if(result.option1 != undefined){
          let para1 = event.querySelectorAll('.user-options')[0];
          para1.querySelector('input[data-value="'+ result.option1 +'"]').checked = true;
      }
        if(result.option2 != undefined){
          let para2 = event.querySelectorAll('.user-options')[1];
          para2.querySelector('input[data-value="'+ result.option2 +'"]').checked = true;
      }
        if(result.option3 != undefined){
          let para3 = event.querySelectorAll('.user-options')[2];
          para3.querySelector('input[data-value="'+ result.option3 +'"]').checked = true;
      }
}
function attachModalEventListeners(event) {
  var saveButtons = event.querySelectorAll(".sywm-radio>input");
  for (var i = 0; i < saveButtons.length; i++) {
    saveButtons[i].addEventListener("change", function(e) {
       var paradiv = e.target.closest('.modal-guts');
        var mainpara = paradiv.closest('.variants_options_main');
        ShowVariants(mainpara)
        setTimeout(function() {
          saveSelection(e);      
        },100)
      
    });
  }
}
function saveSelection(event) {
  var paradiv = event.target.closest('.modal-guts');
  var SelectorMain = paradiv.querySelector(".user-options");
  var userSelectionData = getSelectTagValues(paradiv,SelectorMain);
  var variant = findVariant(userSelectionData);
  removeProductFromWishlist(variantButtonAttributes, function(removedProduct) {
    var newProductVariantAttributes = {
      empi: removedProduct.empi,
      epi: variant.id,
      du: removedProduct.du
    }
    addProductToWishlist(newProductVariantAttributes);
  });
}
function getSelectTagValues(paradiv,selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var elemNode = selector;
    $(elemNode).each(function(e){
      var optionValue = $(this).find('input[type="radio"]:checked').data('value');
      console.log("optionValue-->",optionValue)
      var key = "option" + (e + 1);      
      var selectedValueObj = _defineProperty({}, key, optionValue);
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    });       
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption) {
  var keys = Object.keys(userSelectedOption).filter(function(key) {
    return userSelectedOption[key] !== null && userSelectedOption[key] !== undefined;
  });

  var match = completeProductJson.variants.find(function(variant){
    return keys.every(function(key, value) {
      return (variant[key] === (userSelectedOption[key].toString()) && variant[value] === userSelectedOption[value]);
    });
  });
  return match;
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function(r) {
    console.log("Removing current Variant")
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  window._swat.addToWishList(new_product_variant, function(r) {
    swymRenderWishlist(window._swat);
  });
}
function renderWishlistUI() {
  // Use the main rendering function for consistency
  if (window._swat) {
    swymRenderWishlist(window._swat);
    return;
  }
  
  _swat.fetch(function(products) {
    //console.log('Item',products);
    //WishlistedProducts = structuredClone(products);
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          //console.log("loop 2 started - " + j + " - " + fullProductDetails.variants[j]);
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
            //console.log("match found - " + fullProductDetails.variants[j].id);
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        } 
      });
    }
    setTimeout(function(e){      
      $('.swym-wishlist-image').each(function(e){        
        var this_imgsrc = $(this).attr('src');
        var new_src = this_imgsrc.replace('_620x620', '');
        $(this).attr('src',new_src);
      });

      var h3height = 0;
    $('.wrappr_tl_prc').each(function() {
    if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.wrappr_tl_prc').height(h3height);
      
    },2000); 
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    currentUserWishlist = products;
    var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
     p.available = !_swat.platform.isEpiOOS(p.epi);
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    console.log(productCardsMarkup)
    attachClickListeners();
       
  });
//  setTimeout(showSoldOut, 1000);
}
function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Add to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
	}, function(e) {
		console.log(e);
	});
}
function countWishlist(){
  window._swat.fetch( function(r) {
    var counterElement = document.querySelector('.swym-wishlist-header-counter');
    if (counterElement) {
      counterElement.innerHTML = r.length;
    }
    // Also update with jQuery if available
    if (typeof $ !== 'undefined') {
      $('.swym-wishlist-header-counter').html(r.length);
    }
  });
}